import { Button, Container, Flex } from '@chakra-ui/react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FilterList from '@/assets/icons/ic-filter-list.svg';

import { Section } from '@/components/ui/core/Section/Section';
import { SearchInputFormCompatible } from '@/components/ui/shared/inputs/SearchInput/SearchInputFormCompatible';
import { DrawerState } from '@/enums/DrawerState';

export const LectureSearchRedirectInput: FC = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { register, handleSubmit } = useForm();

  function onSubmit({ query }: { query: string }) {
    router.push({ pathname: `/library/search`, query: { query: query } });
  }

  return (
    <Section py={5} bgColor="violet.500" position="sticky" top="63px" zIndex="dropdown">
      <Container centerContent>
        <Flex as="form" onSubmit={handleSubmit(onSubmit)} flexDir={{ base: 'column-reverse', sm: 'row' }} w="full">
          <Button
            as={Link}
            href={`/library/search?drawerState=${DrawerState.OPEN}`}
            mt={{ base: 4, sm: 0 }}
            mr={{ base: 0, sm: 4 }}
            px={{ base: 10, md: 14, lg: 16 }}
            colorScheme="white"
            variant="solid"
            size="md"
            rightIcon={<FilterList />}
          >
            {t('library.filters')}
          </Button>
          <SearchInputFormCompatible
            w="full"
            {...register('query')}
            bg="white"
            color="gray.700"
            borderRadius="full"
            placeholder={t('library.search.placeholder')}
          />
        </Flex>
      </Container>
    </Section>
  );
};
